import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ITimelineEventPlayed } from '@24i/player-base';
import { useAdsData, usePlayerTimes } from '@24i/player-utils-react';
import { millisecondsToSeconds } from '@24i/player-utils';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Countdown } from './styled';
const AD_COUNTDOWN_THRESHOLD = 5000;
export const AdCountdown = ({ playerInstance, className, style }) => {
    const { elapsedTime } = usePlayerTimes(playerInstance);
    const { currentAdBreak, currentAd, nextAdvertisement } = useAdsData(playerInstance);
    const { t } = useTranslation(['sott']);
    const { theme } = useTheme();
    const combinedStyle = useMemo(() => (Object.assign(Object.assign({}, getFont(theme, 'h5')), style)), [style]);
    if (currentAdBreak ||
        currentAd ||
        !nextAdvertisement ||
        nextAdvertisement.played === ITimelineEventPlayed.PLAYED ||
        playerInstance.live)
        return null;
    const millisUntilAd = nextAdvertisement.start - elapsedTime;
    if (millisUntilAd <= 0 || millisUntilAd >= AD_COUNTDOWN_THRESHOLD)
        return null;
    const text = t('player.advertisement.countdown', {
        count: Math.ceil(millisecondsToSeconds(millisUntilAd)),
    });
    return (React.createElement(Countdown, { "data-test": "AdCountdown", className: `AdCountdown ${className}`, style: combinedStyle, theme: theme }, text));
};
//# sourceMappingURL=index.js.map